import {useRef, useState} from "react";
import {Toast} from "primereact/toast";
import Sorting from "../data/sorting";
import {InputText} from "primereact/inputtext";
import {Button} from "primereact/button";
import {classNames} from "primereact/utils";
import {createLeaderboardApiCall} from "../utils/apiCalls";
import {Leaderboard} from "../data/leaderboard";
import {Dropdown} from "primereact/dropdown";

function LeaderboardCreation({onLeaderboardCreated}: { onLeaderboardCreated(leaderboard: Leaderboard): void }) {
    const [isLoading, setIsLoading] = useState(false);
    const [leaderboardName, setLeaderboardName] = useState<string>("");
    const [sorting, setSorting] = useState<Sorting>(Sorting.Descending);

    const toast = useRef<Toast>(null);

    const showCreationSuccess = () => {
        toast.current!.show({
            severity: "success",
            summary: "Leaderboard created",
        });
    };
    const showCreationError = () => {
        toast.current!.show({
            severity: "error",
            summary: "Leaderboard creation failed",
            life: 3000,
        });
    };

    function onCreationClicked(): void {
        setIsLoading(true);

        async function fetchLogin() {

            try {
                const response = await createLeaderboardApiCall(leaderboardName, sorting)
                const json = await response.json();
                const leaderboard = Object.assign(new Leaderboard(), json);

                if (response.ok) {
                    showCreationSuccess();
                    onLeaderboardCreated(leaderboard);
                } else {
                    showCreationError();
                }
            } catch {
                showCreationError();
                return;
            } finally {
                setIsLoading(false);
            }
        }

        fetchLogin();
    }

    return (
        <div>
            <div className="p-fluid mt-3 mb-5">
                <span className="p-float-label">
                  <InputText
                      value={leaderboardName}
                      onChange={(e) => setLeaderboardName(e.target.value)}
                      id="name"
                      className={"w-full " + classNames({"p-invalid": !leaderboardName.trim()})}/>
                  <label htmlFor="name">Name</label>
                </span>
            </div>
            <div className="p-fluid my-3">
                <span className="p-float-label">
                    <Dropdown
                        id="sorting"
                        value={sorting}
                        onChange={(e) => setSorting(e.target.value)}
                        options={[Sorting.Descending, Sorting.Ascending]}
                        optionLabel="name"
                        className="w-full"/>
                    <label htmlFor="sorting">Sorting</label>
               </span>
            </div>

            <Button
                loading={isLoading}
                disabled={
                    leaderboardName.length == 0 || sorting === null
                }
                label="Create"
                onClick={onCreationClicked}
                className="w-full"
            />
            <Toast ref={toast}/>
        </div>
    );

}

export default LeaderboardCreation;
